import React from 'react';
import { bool, string } from 'prop-types';
import clsx from 'clsx';
import { IconContext } from 'react-icons';
import {
  FaCircleCheck as CircleCheck,
  FaComputer as Devices,
  FaThumbsUp as ThumbsUp,
} from 'react-icons/fa6';
import { FormattedMessage } from '../../../../util/reactIntl';
import { propTypes } from '../../../../util/types';
import { NamedLink, VideoPlayer } from'../../../../components';
import config from '../../../../config';


import css from './SectionBnbsFeaturedIn.module.css';

const SectionBnbsFeaturedIn = props => {
  const { rootClassName, className } = props;
  const classes = clsx(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.title}>
        <FormattedMessage id="SectionBnbsFeaturedIn.title" />
        <br />
      </div>
      <div className={css.steps}>
        <div className={css.tourlyVideo}>
          <VideoPlayer
            videoURL={config.videoURL['rtpMadeiraFeature']}
            controls={true}
            videoWidth="100%"
          />
        </div>
        {/* <ReactPlayer
          url={config.videoURL['rtpMadeiraFeature']}
          className="react-player"
          controls={true}
          width="509px"
          height="275px"
          config={{
            file: {
              attributes: {
                poster: './poster.jpg',
              },
            },
          }}
        /> */}
        <div className={css.step}>
          <h3 className={css.benefits}>
            <IconContext.Provider
              value={{
                size: 70,
                className: css.icon,
                style: { strokeWidth: 2, fill: 'currentColor' },
              }}
            >
              <CircleCheck />
            </IconContext.Provider>
            <FormattedMessage id="SectionBnbsFeaturedIn.extraRevenue" />
          </h3>
          <br />
          <h3 className={css.benefits}>
            <IconContext.Provider
              value={{
                size: 70,
                className: css.icon,
                style: { strokeWidth: 2, fill: 'currentColor' },
              }}
            >
              <Devices />
            </IconContext.Provider>
            <FormattedMessage id="SectionBnbsFeaturedIn.automaticAndDigital" />
          </h3>
          <br />
          <h3 className={css.benefits}>
            <IconContext.Provider
              value={{
                size: 70,
                className: css.icon,
                style: { strokeWidth: 2, fill: 'currentColor' },
              }}
            >
              <ThumbsUp />
            </IconContext.Provider>
            <FormattedMessage id="SectionBnbsFeaturedIn.noCompromise" />
          </h3>
        </div>
      </div>
      <br />
      <div className={css.stepButtonCTA}>
        <NamedLink name="AffiliateSignupPage" className={css.signUpButton}>
          <FormattedMessage id="SectionHeroSA.browseButton" />
        </NamedLink>
      </div>
    </div>
  );
};

SectionBnbsFeaturedIn.defaultProps = {
  rootClassName: null,
  className: null,
  currentUserListing: null,
  currentUserListingFetched: false,
};

SectionBnbsFeaturedIn.propTypes = {
  rootClassName: string,
  className: string,
  currentUserListing: propTypes.ownListing,
  currentUserListingFetched: bool,
};

export default SectionBnbsFeaturedIn;
